import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "secction1" }
const _hoisted_3 = { class: "secction2" }
const _hoisted_4 = { class: "secction3" }
const _hoisted_5 = { class: "secction4" }

import { ref, reactive } from "vue";
import myheader from "@/components/pcComp/header";
import swiperNews from "@/components/swiperNews";
import simpleSwiper from "@/components/simpleSwiper";
import newTypeCom from "@/components/pcComp/newTypeCom";
import mutilNewTypeCom from "@/components/pcComp/mutilNewTypeCom";
import tyNewTypeCom from "@/components/pcComp/tyNewTypeCom";
import imgNewTypeCom from "@/components/pcComp/imgNewTypeCom";
import enterSICHUANG from "@/components/pcComp/enterSICHUANG";
import footerCom from "@/components/pcComp/footerCom";
import { useRoute, useRouter } from "vue-router";
import { getColumnList, getSettingList } from "../../request/api";
import { ElLoading } from "element-plus";
import "element-plus/theme-chalk/el-loading.css";

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

name: "PCHome";
const router = useRouter();
const route = useRoute();
const toDetail = () => {
  router.push("/pages/detail/detail");
};
const toList = () => {
  router.push("/pages/list/list");
};

// 获取栏目共所有新闻组件使用
const navList: Array<any> = ref([]);
// 获取栏目
let getColumnData = () => {
  const loading = ElLoading.service({
    lock: true,
    text: "Loading",
    // spinner: "haha",
    // 'custom-class':"haha",
    background: "rgba(0, 0, 0, 0.1)"
  });
  getColumnList({}).then(res => {
    if (res.data.code == 200) {
      navList.value = res.data.data;
      // 插入一个首页
      navList.value.unshift({
        children: [],
        id: 0,
        index: 0,
        link_type: 1,
        link_url: "www.baidu.com",
        name: "首页",
        parent_id: 0
      });
      console.log(navList.value, "navList.value");
    }
    setTimeout(() => {
      loading.close();
    }, 300);
  });
};
getColumnData();

let toLawerHelper = () => {
  window.open("http://aid.sczxmb.com");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "platform",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toLawerHelper) && _unref(toLawerHelper)(...args))),
      src: "https://xiamenban.oss-cn-hangzhou.aliyuncs.com/official/%E5%9B%BE%E5%8F%B8%E6%9C%BA-20230109-33291249.png",
      alt: ""
    }),
    _createVNode(_unref(myheader)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(swiperNews), { ColumnData: navList.value }, null, 8, ["ColumnData"]),
      (navList.value.length)
        ? (_openBlock(), _createBlock(_unref(newTypeCom), {
            key: 0,
            newsID: 1,
            ColumnData: navList.value
          }, null, 8, ["ColumnData"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (navList.value.length)
        ? (_openBlock(), _createBlock(_unref(enterSICHUANG), {
            key: 0,
            newsID: 7,
            ColumnData: navList.value
          }, null, 8, ["ColumnData"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(simpleSwiper))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (navList.value.length)
        ? (_openBlock(), _createBlock(_unref(imgNewTypeCom), {
            key: 0,
            newsID: 4,
            ColumnData: navList.value
          }, null, 8, ["ColumnData"]))
        : _createCommentVNode("", true),
      (navList.value.length)
        ? (_openBlock(), _createBlock(_unref(tyNewTypeCom), {
            key: 1,
            style: {"margin-left":"60px"},
            newsID: 5,
            ColumnData: navList.value
          }, null, 8, ["ColumnData"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (navList.value.length)
        ? (_openBlock(), _createBlock(_unref(mutilNewTypeCom), {
            key: 0,
            newsIDList: [2,6,3],
            ColumnData: navList.value
          }, null, 8, ["ColumnData"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(footerCom))
  ]))
}
}

})